(() => {
  const translations=JSON.parse(document.querySelector('[data-b2c-i18n]')?.textContent||'{}');
  const tr=text=>translations[text]||text;
  document.querySelector('[data-b2c-language]')?.addEventListener('change',event=>event.target.form.requestSubmit());
  const root = (window.Shopify?.routes?.root || '/').replace(/\/?$/, '/');
  const launch = document.body.dataset.launch === 'true';
  const overviewDialog=document.querySelector('[data-overview-dialog]');
  if(overviewDialog){
    document.querySelector('[data-overview-open]')?.addEventListener('click',()=>overviewDialog.showModal());
    overviewDialog.querySelector('[data-overview-close]').addEventListener('click',()=>overviewDialog.close());
    overviewDialog.addEventListener('click',event=>{if(event.target===overviewDialog)overviewDialog.close();});
  }
  const money = cents => new Intl.NumberFormat(document.documentElement.lang || 'it', { style: 'currency', currency: 'EUR' }).format(cents / 100);
  const safeJson = element => { try { return JSON.parse(element?.textContent || '{}'); } catch { return {}; } };
  document.querySelectorAll('[data-quantity-stepper]').forEach(control=>{
    const input=control.querySelector('input');
    const minus=control.querySelector('[data-quantity-change="-1"]');
    const plus=control.querySelector('[data-quantity-change="1"]');
    const sync=()=>{
      const value=input.value===''?Number(input.min || 0):Number(input.value);
      minus.disabled=input.disabled || value<=Number(input.min || 0);
      plus.disabled=input.disabled || (input.max!=='' && value>=Number(input.max));
    };
    control.querySelectorAll('[data-quantity-change]').forEach(button=>button.addEventListener('click',()=>{
      if(input.value==='' || !Number.isFinite(Number(input.value))) input.value=input.min || '0';
      else if(Number(button.dataset.quantityChange)>0) input.stepUp();
      else input.stepDown();
      input.dispatchEvent(new Event('input',{bubbles:true}));
      input.dispatchEvent(new Event('change',{bubbles:true}));
    }));
    input.addEventListener('input',sync);input.addEventListener('change',sync);sync();
  });
  const colourFor = variant => ({'00270923':'nero','00270924':'royal-blu','00270925':'grigio','00270926':'terra'}[variant.sku] || ({Nero:'nero',Terra:'terra',Grigio:'grigio','Royal Blue':'royal-blu'}[variant.title]) || 'nero');
  const purchase = document.querySelector('[data-purchase]');
  const flyQuantity = cart => cart.items.filter(item => Number(item.product_id) === 16113564352890).reduce((total,item)=>total+item.quantity,0);
  const campaignCodes = cart => {
    const codes=(cart.discount_codes || []).map(item=>item.code).filter(code=>code.toUpperCase() !== 'FLY100');
    if(launch && flyQuantity(cart) === 1 && !codes.length) codes.push('FLY100');
    return codes.join(',');
  };
  if (purchase) {
    const form = purchase.querySelector('form');
    const variants = safeJson(purchase.querySelector('[data-purchase-variants]'));
    const assets = safeJson(purchase.querySelector('[data-purchase-assets]'));
    const photo = purchase.querySelector('[data-purchase-photo]');
    const price = purchase.querySelector('[data-variant-price]');
    const status = purchase.querySelector('[data-purchase-status]');
    const qty = form.querySelector('[name="quantity"]');
    let view = '01-frontale';
    let variant = variants.find(item => String(item.id) === form.querySelector('[name="id"]:checked')?.value) || variants[0];
    function sync() {
      const colour = colourFor(variant);
      photo.src = assets[colour].replace('01-frontale', view);
      photo.alt = `FlySmart ${variant.title}, ${purchase.querySelector(`[data-purchase-view="${view}"]`).textContent}`;
      price.textContent = money(variant.price);
      const offer = purchase.querySelector('.launch-card p strong');
      if (offer) offer.textContent = money(Math.round(variant.price * .9));
      form.querySelector('[name="add"]').disabled = !variant.available;
      if (variant.inventory_management && variant.inventory_policy !== 'continue' && Number.isFinite(variant.inventory_quantity)) qty.max = variant.inventory_quantity;
      else qty.removeAttribute('max');
      qty.dispatchEvent(new Event('change',{bubbles:true}));
    }
    purchase.querySelectorAll('[data-variant-radio]').forEach(input => input.addEventListener('change', () => {
      variant = variants.find(item => String(item.id) === input.value);
      status.textContent = '';
      sync();
      if (location.pathname.includes('/products/')) {
        const url = new URL(location.href); url.searchParams.set('variant', variant.id); history.replaceState({}, '', url);
      }
    }));
    purchase.querySelectorAll('[data-purchase-view]').forEach(button => button.addEventListener('click', () => {
      view = button.dataset.purchaseView;
      purchase.querySelectorAll('[data-purchase-view]').forEach(other => other.setAttribute('aria-pressed', String(other === button)));
      sync();
    }));
    document.querySelector('[data-fly-product-link]')?.addEventListener('click', () => {
      const colour = document.querySelector('[data-color-target="photo"][aria-pressed="true"]')?.dataset.flyColor;
      const choice = variants.find(item => colourFor(item) === colour);
      const radio = choice && form.querySelector(`[value="${choice.id}"]`);
      if (radio && !radio.disabled) { radio.checked = true; radio.dispatchEvent(new Event('change')); }
    });
    const dialog = document.querySelector('[data-photo-dialog]');
    purchase.querySelector('[data-photo-open]').addEventListener('click', () => {
      const large = dialog.querySelector('[data-photo-large]'); large.src = photo.src; large.alt = photo.alt; dialog.showModal();
    });
    dialog.querySelector('[data-photo-close]').addEventListener('click', () => dialog.close());
    dialog.addEventListener('click', event => { if (event.target === dialog) dialog.close(); });
    form.addEventListener('submit', async event => {
      event.preventDefault();
      if (!form.reportValidity()) return;
      const button = form.querySelector('[name="add"]');
      const label = button.textContent;
      button.disabled = true; button.textContent = tr("Aggiungo…"); status.textContent = '';
      try {
        const response = await fetch(root + 'cart/add.js', { method: 'POST', body: new FormData(form), headers: { Accept: 'application/json' } });
        const data = await response.json();
        if (!response.ok) throw new Error(data.description || tr("Impossibile aggiungere il prodotto. Riprova."));
        try {
          const currentCart=await (await fetch(root+'cart.js')).json();
          await fetch(root + 'cart/update.js', { method:'POST', headers:{'Content-Type':'application/json'}, body:JSON.stringify({discount:campaignCodes(currentCart)}) });
        } catch {}
        location.assign(root + 'cart');
      } catch (error) { status.textContent = error.message || tr("Connessione non disponibile. Riprova."); button.disabled = false; button.textContent = label; }
    });
    sync();
  }
  const cartForm = document.querySelector('.cart-layout');
  const optIn = document.querySelector('[data-launch-opt-in]');
  if (cartForm) {
    const note = document.querySelector('[data-discount-status]');
    const checkout = cartForm.querySelector('[name="checkout"]');
    let updating = false;
    const setDiscount = async () => {
      if(updating) return;
      updating = true; checkout.disabled = true;
      try {
        const currentCart=await (await fetch(root+'cart.js')).json();
        const response = await fetch(root + 'cart/update.js', { method:'POST', headers:{'Content-Type':'application/json'}, body:JSON.stringify({discount:campaignCodes(currentCart)}) });
        const cart = await response.json();
        if (!response.ok) throw new Error(cart.description || tr("Riprova ad applicare il codice."));
        const discount = cart.discount_codes?.find(item => item.code.toUpperCase() === 'FLY100');
        if (Number(cartForm.dataset.totalPrice) !== cart.total_price) { location.reload(); return; }
        if(note) note.textContent = flyQuantity(cart)>=2 ? tr("Da 2 zaini: 69,90 € ciascuno. Sconto quantità automatico, non cumulabile. Spedizione gratuita in Italia.") : discount?.applicable ? tr("FLY100 applicato: 80,91 € per zaino. Offerta primi 100 ordini.") : tr("Eventuali codici personali e il totale finale sono verificati al checkout.");
      } catch { if(note) note.textContent = tr("Il checkout verifica lo sconto quantità o il codice personale."); }
      finally { updating = false; checkout.disabled = false; }
    };
    optIn?.addEventListener('change', setDiscount);
    setDiscount();
  }
  document.querySelector('a[href$="#faq"]')?.addEventListener('click', () => document.querySelector('.faq')?.setAttribute('id','faq'));
  document.querySelector('.faq')?.setAttribute('id','faq');
  const sticky = document.querySelector('.sticky-buy');
  if(sticky && (location.pathname.includes('/cart') || location.pathname.includes('/policies'))) sticky.hidden = true;
  const counter = document.querySelector('[data-launch-counter]');
  if (counter) {
    let refreshing = false;
    const refreshCounter = async () => {
      if (document.hidden || refreshing) return;
      refreshing = true;
      try {
        const url = new URL(location.href); url.hash = ''; url.searchParams.set('sections', counter.dataset.sectionId);
        const response = await fetch(url, { headers:{Accept:'application/json'}, cache:'no-store' });
        if (!response.ok) return;
        const sections = await response.json();
        const html = sections[counter.dataset.sectionId];
        if (!html) return;
        const next = new DOMParser().parseFromString(html,'text/html').querySelector('[data-launch-counter]');
        const remaining = Number(next?.dataset.remaining);
        if (!next || !Number.isInteger(remaining) || remaining < 0 || remaining > 100) return;
        counter.dataset.remaining = remaining;
        counter.style.setProperty('--counter-hue', String(remaining * 1.2));
        counter.querySelector('[data-counter-number]').textContent = remaining;
        counter.querySelector('[data-counter-bar]').style.width = remaining + '%';
        counter.querySelector('[data-counter-message]').textContent = !remaining ? tr("La promozione di lancio è terminata") : remaining <= 20 ? tr("Affrettati, gli ordini in promozione stanno per finire") : tr("Solo 100 ordini a 80,91 € con FLY100");
        if (!remaining) {
          document.body.dataset.launch = 'false';
          document.querySelectorAll('.launch-card,.announcement,.cart-launch').forEach(item=>item.hidden=true);
        }
      } catch {} finally { refreshing = false; }
    };
    setInterval(refreshCounter, 60000);
    document.addEventListener('visibilitychange',()=>{if(!document.hidden)refreshCounter();});
  }
})();
